<div class="authentication">
    <div class="page-404 container">
        <div class="row">
            <div class="col-md-6">
                <div class="full-height">
                    <div class="vertical-align full-height pdd-horizon-70">
                        <div class="table-cell">
                            <div *ngIf="isServerAvailable">
                                <h1
                                    class="text-dark font-size-80 text-light"
                                    style="text-align: left"
                                >
                                    {{
                                        'pages.service-unavailable.servers-running'
                                            | translate
                                    }}
                                </h1>
                                <p class="lead lh-1-8">
                                    {{
                                        'pages.service-unavailable.servers-running-message'
                                            | translate
                                    }}
                                </p>
                            </div>

                            <div *ngIf="!isServerAvailable">
                                <h1
                                    class="text-dark font-size-80 text-light"
                                    style="text-align: left"
                                >
                                    {{
                                        'pages.service-unavailable.under-maintenance'
                                            | translate
                                    }}
                                </h1>
                                <p class="lead lh-1-8">
                                    {{
                                        'pages.service-unavailable.under-maintenance-message'
                                            | translate
                                    }}
                                </p>
                            </div>

                            <a
                                (click)="getServerStatus(true)"
                                class="btn btn-info"
                            >
                                {{
                                    !isServerAvailable
                                        ? ('pages.service-unavailable.try-again'
                                          | translate)
                                        : ('pages.service-unavailable.proceed-with-in2'
                                          | translate)
                                }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-5 ml-auto hidden-sm hidden-xs">
                <div class="full-height height-100">
                    <div class="vertical-align full-height">
                        <div class="table-cell">
                            <img
                                *ngIf="isServerAvailable"
                                class="img-responsive"
                                src="images/others/success.png"
                                alt=""
                            />
                            <img
                                *ngIf="!isServerAvailable"
                                class="img-responsive"
                                src="images/others/maintenance.png"
                                alt=""
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
